var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (Array, MULTI_CARRIER_ELIGIBILITY, MULTI_CARRIER_ENABLED, detail) {




pug_mixins["addressWithEdit"] = pug_interp = function({prefix, link, showEdit = true, label = 'Street Address', testIdPrefix = ''}){
var block = (this && this.block), attributes = (this && this.attributes) || {};
prefix = prefix || ''
const location = `<span id="${prefix}location-info"></span>`
const messageHelpEdit = link
  ? `${location} <a class="change-location" id="${prefix}edit-location" href="${link}">(Change location)</a>`
  : `${location} <a id="${prefix}edit-location" href="javascript:void(0)">edit</a>`
const messageHelp = showEdit ? messageHelpEdit : location
const addressAttrs = testIdPrefix ? {'data-testid': `${testIdPrefix}-addressInput`} : {}
const zipAttrs = testIdPrefix ? {'data-testid': `${testIdPrefix}-zipInput`, autocomplete: 'off', placeholder: '#####'} : {autocomplete: 'off', placeholder: '#####'}
const stateAttrs = testIdPrefix ? {'data-testid': `${testIdPrefix}-stateSelect`} : {}
const cityAttrs = testIdPrefix ? {'data-testid': `${testIdPrefix}-citySelect`} : {}
const countyAttrs = testIdPrefix ? {'data-testid': `${testIdPrefix}-countySelect`} : {}

pug_mixins["input"]({name: `${prefix}address`, type: 'text', label , help: messageHelp, attributes: addressAttrs});
pug_html = pug_html + "\u003Cdiv" + (" class=\"Form__fields Form__pair hidden\""+pug.attr("id", `${prefix}address-combo`, true, true)) + "\u003E";
pug_mixins["input"]({name: `${prefix}zip`, type: 'tel', label: 'Zip Code', help: 'example: 00123', attributes: zipAttrs});
pug_mixins["input"]({name: `${prefix}state`, type: 'select', label: 'State', attributes: stateAttrs});
pug_mixins["input"]({name: `${prefix}city`, type: 'select', label: 'City', attributes: cityAttrs});
pug_mixins["input"]({name: `${prefix}county`, type: 'select', label: 'County', attributes: countyAttrs});
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};





























































































pug_mixins["itemType"] = pug_interp = function(value){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (typeof value === 'string') {
pug_html = pug_html + "\u003Cp\u003E" + (pug.escape(null == (pug_interp = value) ? "" : pug_interp)) + "\u003C\u002Fp\u003E";
}
else
if (Array.isArray(detail)) {
// iterate value
;(function(){
  var $$obj = value;
  if ('number' == typeof $$obj.length) {
      for (var index = 0, $$l = $$obj.length; index < $$l; index++) {
        var item = $$obj[index];
pug_html = pug_html + "\u003Cdiv class=\"detail__subtitle\"\u003E" + (pug.escape(null == (pug_interp = index) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
pug_mixins["itemType"](item);
      }
  } else {
    var $$l = 0;
    for (var index in $$obj) {
      $$l++;
      var item = $$obj[index];
pug_html = pug_html + "\u003Cdiv class=\"detail__subtitle\"\u003E" + (pug.escape(null == (pug_interp = index) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
pug_mixins["itemType"](item);
    }
  }
}).call(this);

}
else
if (typeof value === 'object') {
// iterate value
;(function(){
  var $$obj = value;
  if ('number' == typeof $$obj.length) {
      for (var index = 0, $$l = $$obj.length; index < $$l; index++) {
        var item = $$obj[index];
if (typeof index !== 'number') {
pug_html = pug_html + "\u003Cdiv class=\"detail__subtitle\"\u003E" + (pug.escape(null == (pug_interp = index) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
pug_mixins["itemType"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"detail__content\"\u003E\u003Cspan\u003E" + (pug.escape(null == (pug_interp = item) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E";
}
}, item);
      }
  } else {
    var $$l = 0;
    for (var index in $$obj) {
      $$l++;
      var item = $$obj[index];
if (typeof index !== 'number') {
pug_html = pug_html + "\u003Cdiv class=\"detail__subtitle\"\u003E" + (pug.escape(null == (pug_interp = index) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
pug_mixins["itemType"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"detail__content\"\u003E\u003Cspan\u003E" + (pug.escape(null == (pug_interp = item) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E";
}
}, item);
    }
  }
}).call(this);

}
};


















var endpoints = require('core/constants/endpoints')




var endpoints = require('core/constants/endpoints')








const blocksDisclaimer = {}
pug_mixins["disclaimer"] = pug_interp = function(options = {}){
var block = (this && this.block), attributes = (this && this.attributes) || {};
const { forBTM } = options
pug_html = pug_html + "\u003Cdiv class=\"disclaimer\"\u003E\u003Cp class=\"d-none michigan-epic-plan-disclaimer\"\u003EMichigan’s nonopioid directive form is available at this&nbsp;\u003Ca href=\"https:\u002F\u002Fwww.michigan.gov\u002Fopioids\u002Ffind-help\" target=\"_blank\" rel=\"noopener noreferrer\"\u003Elink.\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003Ch4 class=\"disclaimer__title\" id=\"underwritten_title\"\u003EMedical plans underwritten by" + (pug.escape(null == (pug_interp = ' ') ? "" : pug_interp)) + "\u003Cspan class=\"d-none d-clic-inline\"\u003ECompanion Life Insurance Company\u003Cspan class=\"d-none d-nric-inline\"\u003E&nbsp;,&nbsp;\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"d-none d-nric-inline\"\u003ENorth River Insurance Company\u003Cspan class=\"d-none d-sure_care-inline\"\u003E&nbsp;,&nbsp;\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"d-none d-sure_care-inline\"\u003E Pan-American Life Insurance Company\u003C\u002Fspan\u003E.\u003C\u002Fh4\u003E";
if (block) {
block && block();
}
pug_html = pug_html + "\u003Cdiv class=\"d-none d-clic-block\"\u003E\u003Cp class=\"limitation-exclusions-footer\"\u003ESee Plan Details for Limitations and Exclusions.\u003C\u002Fp\u003E" + (null == (pug_interp = require("../../../../pug/mixins/disclaimer/commission-disclosure.pug").call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = require("../../../../pug/mixins/disclaimer/content.pug").call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = require("../../../../pug/mixins/disclaimer/plan.pug").call(this, locals)) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"d-none d-sure_care-block\"\u003E\u003Cdiv class=\"d-clic-none\"\u003E\u003Cdiv class=\"d-nric-none\"\u003E\u003Cp class=\"limitation-exclusions-footer\"\u003ESee Plan Details for Limitations and Exclusions.\u003C\u002Fp\u003E" + (null == (pug_interp = require("../../../../pug/mixins/disclaimer/commission-disclosure.pug").call(this, locals)) ? "" : pug_interp) + "\u003Cp\u003EUnderwritten by Pan-American Life Insurance Company\u003C\u002Fp\u003E" + (null == (pug_interp = require("../../../../pug/mixins/disclaimer/sure-care.pug").call(this, locals)) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
if (!forBTM) {
pug_html = pug_html + ("\u003Cdiv class=\"d-none d-nric-block\"\u003E\u003Cdiv class=\"d-clic-none\"\u003E" + (null == (pug_interp = require("../../../../pug/mixins/disclaimer/north-river.pug").call(this, locals)) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E" + (null == (pug_interp = require("../../../../pug/mixins/disclaimer/dental.pug").call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = require("../../../../pug/mixins/disclaimer/latitude-large.pug").call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = require("../../../../pug/mixins/disclaimer/flex-benefits.pug").call(this, locals)) ? "" : pug_interp));
pug_mixins["cignaDisclaimer"]();
}
else {
pug_html = pug_html + ((null == (pug_interp = require("../../../../pug/mixins/disclaimer/dental.pug").call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = require("../../../../pug/mixins/disclaimer/latitude.pug").call(this, locals)) ? "" : pug_interp));
}
if (blocksDisclaimer.footer) {
blocksDisclaimer.footer()
}
pug_html = pug_html + (null == (pug_interp = require("../../../../pug/mixins/disclaimer/ada/view.pug").call(this, locals)) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
};




pug_mixins["cignaDisclaimer"] = pug_interp = function(conf = {}){
var block = (this && this.block), attributes = (this && this.attributes) || {};
const show = conf.show || false
const showStatistics = typeof conf.showStatistics === 'boolean' ? conf.showStatistics : true

pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["disclaimer__cigna",show ? '' : 'd-none d-cigna-block'], [false,true]), false, true)) + "\u003E\u003Ch4 class=\"disclaimer__title\"\u003E About the Cigna PPO Network";
if (show) {
pug_html = pug_html + "†";
}
pug_html = pug_html + "\u003C\u002Fh4\u003E\u003Cp\u003EPivot Health is an independent company and is not an affiliate of Cigna. All Cigna products and services are provided exclusively by or through operating subsidiaries of Cigna Corporation, including Cigna Health and Life Insurance Company. The Cigna name, logo and other Cigna marks are owned by Cigna Intellectual Property, Inc.\u003C\u002Fp\u003E\u003Cp\u003E† The Cigna PPO Network refers to the network of providers (doctors, hospitals, specialists) contracted as part of the Cigna PPO Network for Shared Administration, provider counts as of November 1, 2018. Data is subject to change.\u003C\u002Fp\u003E";
if (showStatistics) {
pug_html = pug_html + "\u003Cp class=\"js-statistics-show\"\u003E†† Average discount based on actual paid claims for the period 1\u002F1\u002F17–12\u002F31\u002F17. Cigna analysis conducted in November 2018. Actual results may vary based on utilization, plan design and geography. Cigna analysis of the actual number of doctors in the PPO Network as of November 1, 2018. Data is subject to change.\u003C\u002Fp\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};



































































pug_mixins["faq"] = pug_interp = function(faq, index){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["faq",faq.class || false], [false,true]), false, true)+pug.attr("onclick", `dataLayerPushEvent("EXPAND_FAQ_LANDING-${faq.slug}")`, true, true)+pug.attr("id", `faq-wrap-${faq.slug}`, true, true)) + "\u003E\u003Cbutton" + (pug.attr("class", pug.classes(["faq__question","d-block","text-left",`faq__collapse--${index}`], [false,false,false,true]), false, true)+" type=\"button\" data-toggle=\"collapse\""+pug.attr("data-target", `#faq__collapse--${index}`, true, true)+pug.attr("aria-expanded", faq.expanded, true, true)+pug.attr("aria-controls", `faq__collapse--${index}`, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = faq.question) ? "" : pug_interp)) + "\u003C\u002Fbutton\u003E\u003Cdiv" + (pug.attr("class", pug.classes([`faq__collapse collapse ${faq.expanded === 'true' ? 'show' : ''}`], [true]), false, true)+pug.attr("id", `faq__collapse--${index}`, true, true)) + "\u003E\u003Cdiv class=\"faq__answer\"\u003E";
if (Array.isArray(faq.answer)) {
pug_html = pug_html + "\u003Cul\u003E";
// iterate faq.answer
;(function(){
  var $$obj = faq.answer;
  if ('number' == typeof $$obj.length) {
      for (var pug_index2 = 0, $$l = $$obj.length; pug_index2 < $$l; pug_index2++) {
        var answer = $$obj[pug_index2];
pug_html = pug_html + "\u003Cli\u003E" + (null == (pug_interp = answer) ? "" : pug_interp) + "\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index2 in $$obj) {
      $$l++;
      var answer = $$obj[pug_index2];
pug_html = pug_html + "\u003Cli\u003E" + (null == (pug_interp = answer) ? "" : pug_interp) + "\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ful\u003E";
}
else {
pug_html = pug_html + (null == (pug_interp = faq.answer) ? "" : pug_interp);
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
pug_mixins["faqTitle"] = pug_interp = function(tag = 'h4'){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_mixins["tag"].call({
block: function(){
pug_html = pug_html + "Top FAQs about Pivot Health";
block && block();
},
attributes: pug.merge([{"class": "faqs__title"},attributes])
}, tag);
};















pug_mixins["faqTitle"] = pug_interp = function(tag = 'h4'){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_mixins["tag"].call({
block: function(){
pug_html = pug_html + "Top FAQs about Pivot Health";
block && block();
},
attributes: pug.merge([{"class": "faqs__title"},attributes])
}, tag);
};
pug_mixins["faqItem"] = pug_interp = function(faq, index){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["faq",faq.class || false], [false,true]), false, true)+pug.attr("id", `faq-wrap-${faq.slug}`, true, true)) + "\u003E\u003Ch5" + (pug.attr("class", pug.classes(["faq__question",`faq__question--${index}`], [false,true]), false, true)) + "\u003E" + (pug.escape(null == (pug_interp = faq.question) ? "" : pug_interp)) + "\u003C\u002Fh5\u003E\u003Cdiv" + (" class=\"faq__answer\""+pug.attr("id", `faq__answer--${index}`, true, true)) + "\u003E";
if (Array.isArray(faq.answer)) {
pug_html = pug_html + "\u003Cul\u003E";
// iterate faq.answer
;(function(){
  var $$obj = faq.answer;
  if ('number' == typeof $$obj.length) {
      for (var pug_index4 = 0, $$l = $$obj.length; pug_index4 < $$l; pug_index4++) {
        var answer = $$obj[pug_index4];
pug_html = pug_html + "\u003Cli\u003E" + (null == (pug_interp = answer) ? "" : pug_interp) + "\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index4 in $$obj) {
      $$l++;
      var answer = $$obj[pug_index4];
pug_html = pug_html + "\u003Cli\u003E" + (null == (pug_interp = answer) ? "" : pug_interp) + "\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ful\u003E";
}
else {
pug_html = pug_html + (null == (pug_interp = faq.answer) ? "" : pug_interp);
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};

















































pug_mixins["burgerCheck"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cinput class=\"Header__burger-check d-md-none\" type=\"checkbox\" id=\"header-burger-check\"\u003E";
};
pug_mixins["burgerIcon"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
const { IS_AGENT } = require('core/constants/environment')
pug_html = pug_html + "\u003Clabel" + (pug.attr("class", pug.classes([IS_AGENT ? '' : 'Header__burger--small',"Header__burger","d-md-none"], [true,false,false]), false, true)+" for=\"header-burger-check\"") + "\u003E\u003Cspan class=\"Header__burger-line Header__burger-line--top d-block\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"Header__burger-line Header__burger-line--beef d-block\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"Header__burger-line Header__burger-line--bottom d-block\"\u003E\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
};
const optionsAttributes = {
  email: {
    href: 'mailto:morgan@pivothealth.com',
    class: 'd-inline'
  },
  call: {
    href: '#',
    class: 'promo_number d-md-none',
    onclick: 'dataLayerPushEvent(\'CALL_LANDING-HEADER\')'
  },
  chat: {
    href: '#',
    class: 'js-chat d-none d-chat-ready-inline'
  }
}


const defaultOptions = ['Email', 'Call', 'Chat']

pug_mixins["promoNumberFormattedLink"] = pug_interp = function(IS_ENROLL){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cimg" + (" class=\"image-icon-call\""+pug.attr("src", require('images/icons/telephone-fill.svg'), true, true)) + "\u003E\u003Ca" + (" class=\"font-weight-bold promo_number promo_number_formatted_dash\""+" id=\"about-nav__call-action\" onclick=\"dataLayerPushEvent('CALL_LANDING-HEADER')\""+pug.attr("data-toggle", (IS_ENROLL ? "modal" : false), true, true)+pug.attr("data-target", (IS_ENROLL ? "#header-modal" : false), true, true)) + "\u003E\u003C\u002Fa\u003E";
};


























pug_mixins["environmentBanner"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv class=\"Header__environment-banner d-none\" id=\"header_env_banner\"\u003E\u003Cspan\u003E You are viewing an INACTIVE website page.\u003Cbr\u003EPlease\u003Ca class=\"Header__environment-banner-link\"\u003Eclick here\u003C\u002Fa\u003Eand you will be redirected to the ACTIVE Pivot Health website. \u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E";
};
pug_mixins["error"] = pug_interp = function(id, config){
var block = (this && this.block), attributes = (this && this.attributes) || {};
var raw = config.attributes && config.attributes['data-testid'] ? config.attributes['data-testid'] : ''
var testId = config.errorTestId || (raw ? (raw.includes('Input') || raw.includes('Select') ? raw.replace('Input', 'Error').replace('Select', 'Error') : raw + 'Error') : '')
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["error-message",config.errorClass || false], [false,true]), false, true)+pug.attr("id", `error-${id}`, false, true)+pug.attr("data-testid", testId, false, true)) + "\u003E\u003C\u002Fdiv\u003E";
};
pug_mixins["field"] = pug_interp = function(config){
var block = (this && this.block), attributes = (this && this.attributes) || {};
const id = config.id || config.name
if (config.hit) {
pug_html = pug_html + "\u003Cdiv class=\"hit-text\"\u003E" + (null == (pug_interp = config.hit) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes([`input-field-icon${config.helpInline ? ' d-flex align-items-center' : ''}`], [true]), false, true)) + "\u003E";
if (config.type === 'select') {
pug_html = pug_html + "\u003Cselect" + (pug.attrs(pug.merge([{"class": "form-control","name": config.name,"id": id,"data-testid": pug.escape(`${id}-select`)},attributes]), true)) + "\u003E";
if (config.options) {
// iterate config.options
;(function(){
  var $$obj = config.options;
  if ('number' == typeof $$obj.length) {
      for (var pug_index6 = 0, $$l = $$obj.length; pug_index6 < $$l; pug_index6++) {
        var opt = $$obj[pug_index6];
pug_html = pug_html + "\u003Coption" + (pug.attr("value", opt.value ? opt.value : '', true, true)+pug.attr("selected", opt.selected, true, true)+pug.attr("disabled", opt.disabled, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = opt.label) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index6 in $$obj) {
      $$l++;
      var opt = $$obj[pug_index6];
pug_html = pug_html + "\u003Coption" + (pug.attr("value", opt.value ? opt.value : '', true, true)+pug.attr("selected", opt.selected, true, true)+pug.attr("disabled", opt.disabled, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = opt.label) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
    }
  }
}).call(this);

}
pug_html = pug_html + "\u003C\u002Fselect\u003E";
}
else {
pug_html = pug_html + "\u003Cinput" + (pug.attrs(pug.merge([{"class": "form-control","type": config.type,"name": config.name,"id": id,"data-testid": pug.escape(`${id}-input`)},config.attributes]), true)) + "\u003E";
if (config.icon) {
pug_html = pug_html + "\u003Cspan" + (pug.attr("class", pug.classes([config.icon], [true]), false, true)) + "\u003E\u003C\u002Fspan\u003E";
}
}
if (config.helpInline) {
pug_html = pug_html + "\u003Csmall class=\"help-inline\"\u003E" + (null == (pug_interp = config.helpInline) ? "" : pug_interp) + "\u003C\u002Fsmall\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
if (config.help) {
pug_html = pug_html + "\u003Cp class=\"help-text\"\u003E" + (null == (pug_interp = config.help) ? "" : pug_interp) + "\u003C\u002Fp\u003E";
}
if (!config.errorOutside && config.noError !== true) {
pug_mixins["error"](id, config);
}
};
pug_mixins["input"] = pug_interp = function(config){
var block = (this && this.block), attributes = (this && this.attributes) || {};
const id = config.id || config.name
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes([`form-group input ${config.mainClass || '' }`], [true]), false, true)+pug.attr("id", `wrap-${id}`, false, true)) + "\u003E\u003Clabel" + (pug.attr("class", pug.classes([`${ config.labelClass ? config.labelClass :'form-label'}`], [false]), false, true)+pug.attr("for", id, false, true)) + "\u003E" + (null == (pug_interp = config.label) ? "" : pug_interp) + "\u003C\u002Flabel\u003E";
if (config.sublabel) {
pug_html = pug_html + "\u003Cspan class=\"form-sublabel\"\u003E" + (null == (pug_interp = config.sublabel) ? "" : pug_interp) + "\u003C\u002Fspan\u003E";
}
if (config.tooltip) {
pug_html = pug_html + "\u003Ca" + (" class=\"hc-tooltip-holder\""+" href=\"#\" tabindex=\"0\" data-toggle=\"tooltip\""+pug.attr("title", config.tooltip, false, true)) + "\u003E\u003Ci class=\"hc-icon-tooltip hc-icon-info-circled\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E";
}
if (config.group && Array.isArray(config.group)) {
pug_html = pug_html + "\u003Cdiv class=\"input__group d-flex\"\u003E";
// iterate config.group
;(function(){
  var $$obj = config.group;
  if ('number' == typeof $$obj.length) {
      for (var pug_index7 = 0, $$l = $$obj.length; pug_index7 < $$l; pug_index7++) {
        var conf = $$obj[pug_index7];
conf.id = conf.id || conf.name
pug_html = pug_html + "\u003Cdiv" + (" class=\"input-field\""+pug.attr("id", `wrap-${conf.id}`, false, true)) + "\u003E";
pug_mixins["field"].call({
attributes: conf.attributes
}, conf);
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index7 in $$obj) {
      $$l++;
      var conf = $$obj[pug_index7];
conf.id = conf.id || conf.name
pug_html = pug_html + "\u003Cdiv" + (" class=\"input-field\""+pug.attr("id", `wrap-${conf.id}`, false, true)) + "\u003E";
pug_mixins["field"].call({
attributes: conf.attributes
}, conf);
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cdiv class=\"input-field\"\u003E";
pug_mixins["field"].call({
attributes: config.attributes
}, config);
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
if (config.errorOutside && config.noError !== true) {
pug_mixins["error"](id, config);
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};




pug_mixins["TCPADisclosure"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Clabel" + (pug.attrs(pug.merge([{"id": "leadid_tcpa_disclosure_label"},attributes]), true)) + "\u003E\u003Cinput type=\"hidden\" id=\"leadid_tcpa_disclosure\"\u003E\u003Cp class=\"mb-0\"\u003E\u003Cstrong\u003ELet our agents assist you! We’ll never share your information and only contact you about your coverage.\u003C\u002Fstrong\u003E\nBy submitting your information and clicking below, you represent that you are at least 18 years old and agree to be contacted by  Pivot Health LLC and its affiliates (expressly including Healthcare, Inc. and Build Better Benefits INC) at the number you provided (including any wireless number) regarding various insurance products, through the use of automated telephone dialing systems, pre-recorded messages, and\u002For text messages. Message and data rates may apply. Your consent is not a condition of purchase. This program is subject to our\n\u003Ca href=\"https:\u002F\u002Fwww.pivothealth.com\u002Fprivacy\u002F\" target=\"_blank\" rel=\"noopener noreferrer\"\u003EPrivacy Policy\u003C\u002Fa\u003E\nand\n\u003Ca href=\"https:\u002F\u002Fwww.pivothealth.com\u002Fterms-of-service\u002F\" target=\"_blank\" rel=\"noopener noreferrer\"\u003ETerms of Use.\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003C\u002Flabel\u003E";
};
pug_mixins["loadingSmall"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "loading loading--small text-center align-self-center"},attributes]), true)) + "\u003E\u003Cdiv class=\"loading__body\"\u003E\u003Ci class=\"hc-icon-spinner animate-spin\"\u003E\u003C\u002Fi\u003E";
if (block) {
block && block();
}
else {
pug_html = pug_html + "\u003Cp\u003ELoading...\u003C\u002Fp\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
pug_mixins["loading"] = pug_interp = function(config = {}){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "loading loading--big justify-content-around align-items-center"},attributes]), true)) + "\u003E\u003Cdiv class=\"loading__content text-center flex-grow-1 flex-sm-grow-0\"\u003E\u003Ci class=\"hc-icon-happy-heart loading__icon\"\u003E\u003C\u002Fi\u003E";
block && block();
pug_html = pug_html + "\u003Cdiv class=\"progress\"\u003E\u003Cdiv class=\"progress-bar\" id=\"loading-progress\" role=\"progressbar\" style=\"width: 5%\" aria-valuenow=\"5\" aria-valuemin=\"0\" aria-valuemax=\"100\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};








































pug_mixins["picture"] = pug_interp = function(webp, image){
var block = (this && this.block), attributes = (this && this.attributes) || {};
const className = attributes.class
delete attributes.class
if ((webp && image)) {
pug_html = pug_html + "\u003Cpicture\u003E\u003Csource" + (pug.attrs(pug.merge([{"srcset": pug.escape(webp.srcSet),"type": "image\u002Fwebp","media": "(-webkit-min-device-pixel-ratio: 1.5)"},attributes]), true)) + "\u003E\u003Csource" + (pug.attrs(pug.merge([{"srcset": pug.escape(image.srcSet),"media": "(-webkit-min-device-pixel-ratio: 1.5)"},attributes]), true)) + "\u003E\u003Csource" + (pug.attrs(pug.merge([{"srcset": pug.escape(webp.srcSet),"type": "image\u002Fwebp"},attributes]), true)) + "\u003E\u003Cimg" + (pug.attrs(pug.merge([{"class": pug.classes([className], [true]),"src": pug.escape(image.src),"width": pug.escape(image.width),"height": pug.escape(image.height)},attributes]), true)) + "\u003E\u003C\u002Fpicture\u003E";
}
else {
pug_html = pug_html + "\u003Cimg" + (pug.attrs(attributes, true)) + "\u003E";
}
};















































































pug_mixins["primaryButton"] = pug_interp = function(config){
var block = (this && this.block), attributes = (this && this.attributes) || {};
const id = config.id || config.name
pug_mixins["tag"].call({
block: function(){
if (block) {
block && block();
}
else {
pug_html = pug_html + ("\u003Cspan class=\"primaryButton__cta\"\u003E" + (null == (pug_interp = config.cta) ? "" : pug_interp));
if ((config.withIcon)) {
pug_html = pug_html + "\u003Ci class=\"hc-icon-angle-right\"\u003E\u003C\u002Fi\u003E";
}
pug_html = pug_html + "\u003C\u002Fspan\u003E";
}
},
attributes: pug.merge([{"class": "primaryButton","id": id,"data-testid": pug.escape(id ? `${id}-btn` : false)},attributes])
}, config.tag || 'button');
};
pug_mixins["progressBar"] = pug_interp = function(config){
var block = (this && this.block), attributes = (this && this.attributes) || {};
var navigation = config.navigation || [
  `${routesPath.CENSUS}${config.backTo || ''}`,
  routesPath.QUOTES,
  `${config.enableDetails ? routesPath.DETAILS : routesPath.START_APPLICATION}?planid={{planid}}`,
  `${routesPath.ELIGIBILITY}?planid={{planid}}`,
  `${routesPath.APPLICATION}?planid={{planid}}`
]

pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "ProgressBar d-internal-none","data-testid": "progressBar-container"},attributes]), true)) + "\u003E\u003Cdiv class=\"ProgressBar__sm font-weight-md-bold text-center d-md-none d-flex flex-column align-items-center\"\u003E\u003Cspan class=\"ProgressBar__sm-content\" data-testid=\"progressBar-mobile-label\"\u003EStep " + (pug.escape(null == (pug_interp = config.step) ? "" : pug_interp)) + " of " + (pug.escape(null == (pug_interp = config.steps) ? "" : pug_interp)) + " | " + (pug.escape(null == (pug_interp = config.messages[config.step-1]) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cul class=\"ProgressBar__md text-center d-none d-md-flex\" data-testid=\"progressBar-steps\"\u003E";
var width = 100/config.steps
for (var n = 1; n <= config.steps; n++)
{
var classes = [n <= config.step ? 'active' : '', n == config.step ? 'current' : '']
pug_html = pug_html + ("\u003Cli" + (pug.attr("class", pug.classes([(classes.join(' '))], [true]), false, true)+pug.attr("style", pug.style(`width:${width}%`), true, true)) + "\u003E" + (null == (pug_interp = (`<span class="progress-bar-title ${n === config.step ? 'active-title' : ''}">${config.messages[n-1]}</span>`)) ? "" : pug_interp));
if (n < config.step) {
pug_html = pug_html + "\u003Ca" + (pug.attr("class", pug.classes(["ProgressBar__link","d-block",`${navigation[n - 1].includes(routesPath.CENSUS) ? 'add-plan' : ''}`], [false,false,true]), false, true)+pug.attr("href", navigation[n - 1], true, true)+pug.attr("data-step", n, true, true)+pug.attr("data-testid", `progressBar-step-${n}`, true, true)) + "\u003E\u003C\u002Fa\u003E";
}
pug_html = pug_html + "\u003C\u002Fli\u003E";
}
pug_html = pug_html + "\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E";
};




pug_mixins["radioGroup"] = pug_interp = function(config = {}){
var block = (this && this.block), attributes = (this && this.attributes) || {};
var variations = ['separated', 'checkmark', 'full-width']
var classes = []
variations.map(variation => {
  if (config[variation]) {
    classes.push(`switch-field--${variation}`)
  }
})

pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": pug.classes(["switch-field",classes.length > 0 ? classes : 'switch-field--tight'], [false,true])},attributes]), true)) + "\u003E";
for (var option of config.options)
{
var id = `${config.name}-${option.valueText}`
var testId = config.testId ? `${config.testId}-${option.valueText}` : id
pug_html = pug_html + "\u003Cinput" + (" type=\"radio\""+pug.attr("name", config.name, false, true)+pug.attr("id", id, false, true)+pug.attr("value", option.valueText, true, true)+pug.attr("checked", option.checked, true, true)) + "\u003E\u003Clabel" + (pug.attrs(pug.merge([{"class": "radio__btn radio__btn--active","for": id,"data-testid": testId},option.attributes]), true)) + "\u003E";
if (config.checkmark) {
pug_html = pug_html + "\u003Cspan class=\"radio__checkmark\"\u003E\u003Ci class=\"hc-icon-check\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + (pug.escape(null == (pug_interp = option.label) ? "" : pug_interp)) + "\u003C\u002Flabel\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};



















const showThis = require('core/constants/environment').IS_AGENT




















































pug_mixins["tag"] = pug_interp = function(tag){
var block = (this && this.block), attributes = (this && this.attributes) || {};
switch (tag){
case 'a':
pug_html = pug_html + "\u003Ca" + (pug.attrs(attributes, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fa\u003E";
  break;
case 'button':
pug_html = pug_html + "\u003Cbutton" + (pug.attrs(attributes, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fbutton\u003E";
  break;
case 'strong':
pug_html = pug_html + "\u003Cstrong" + (pug.attrs(attributes, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fstrong\u003E";
  break;
case 'span':
pug_html = pug_html + "\u003Cspan" + (pug.attrs(attributes, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fspan\u003E";
  break;
case 'label':
pug_html = pug_html + "\u003Clabel" + (pug.attrs(attributes, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Flabel\u003E";
  break;
case 'h4':
pug_html = pug_html + "\u003Ch4" + (pug.attrs(attributes, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fh4\u003E";
  break;
default:
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(attributes, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
  break;
}
};
pug_mixins["template"] = pug_interp = function(id){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cscript" + (" type=\"text\u002Ftemplate\""+pug.attr("id", id, true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fscript\u003E";
};













pug_mixins["trustPilotSmall"] = pug_interp = function(config = {}){
var block = (this && this.block), attributes = (this && this.attributes) || {};
const { REVIEWS } = require('sites/routes')
const { IS_ENROLL } = require('core/constants/environment')

pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "trust-small"},attributes]), true)) + "\u003E\u003Cdiv class=\"trustpilot-widget\" data-locale=\"en-US\" data-template-id=\"5406e65db0d04a09e042d5fc\" data-businessunit-id=\"57dff8180000ff000594e8bb\" data-style-height=\"28px\" data-style-width=\"100%\" data-theme=\"light\"\u003E\u003Ca href=\"https:\u002F\u002Fwww.trustpilot.com\u002Freview\u002Fpivothealth.com\" target=\"_blank\" rel=\"noopener noreferrer\"\u003ETrustpilot\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E";
if (IS_ENROLL) {
pug_html = pug_html + "\u003Ca" + (" class=\"trust-link\""+pug.attr("href", REVIEWS, true, true)+" target=\"_blank\" rel=\"noopener noreferrer\"") + "\u003E\u003C\u002Fa\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};


















const {CONNECTME, CONNECTME_MESSAGES} = require('core/constants/thirdParties.ts')
pug_mixins["connectMeHolder"] = pug_interp = function(config){
var block = (this && this.block), attributes = (this && this.attributes) || {};
const {placement, moduleId = "1205"} = config
pug_html = pug_html + "\u003Cdiv" + (" class=\"connectme-status text-center p-3 d-none\""+pug.attr("data-placement", placement, true, true)) + "\u003E\u003Ci class=\"connectme-status__alternative-icon m-3\"\u003E" + (null == (pug_interp = require('!!raw-loader!image-webpack-loader!images/icons/male-call-agent.svg').default) ? "" : pug_interp) + "\u003C\u002Fi\u003E\u003Cdiv class=\"connectme-status__messages pt-5\"\u003E\u003Cp class=\"connectme-status__starting paragraph font-weight-bolder d-none d-starting-block\"\u003E" + (pug.escape(null == (pug_interp = CONNECTME_MESSAGES[CONNECTME.starting]) ? "" : pug_interp)) + "\u003C\u002Fp\u003E\u003Cp class=\"connectme-status__init paragraph font-weight-bolder d-none d-init-block\"\u003E" + (pug.escape(null == (pug_interp = CONNECTME_MESSAGES[CONNECTME.init]) ? "" : pug_interp)) + "\u003C\u002Fp\u003E\u003Cp class=\"connectme-status__ringing paragraph font-weight-bolder d-none d-ringing-block\"\u003E" + (pug.escape(null == (pug_interp = CONNECTME_MESSAGES[CONNECTME.ringing]) ? "" : pug_interp)) + "\u003C\u002Fp\u003E\u003Cp class=\"connectme-status__connected paragraph font-weight-bolder d-none d-connected-block\"\u003E" + (pug.escape(null == (pug_interp = CONNECTME_MESSAGES[CONNECTME.connected]) ? "" : pug_interp)) + "\u003C\u002Fp\u003E\u003Cp class=\"connectme-status__completed paragraph font-weight-bolder d-none d-completed-block\"\u003E" + (pug.escape(null == (pug_interp = CONNECTME_MESSAGES[CONNECTME.completed]) ? "" : pug_interp)) + "\u003C\u002Fp\u003E\u003Cp class=\"connectme-status__failed paragraph font-weight-bolder d-none d-failed-block\"\u003E" + (pug.escape(null == (pug_interp = CONNECTME_MESSAGES[CONNECTME.failed]) ? "" : pug_interp)) + "\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv" + (" class=\"connectme-status__original d-none\""+pug.attr("data-placement", placement, true, true)) + "\u003E\u003Cp" + (" class=\"g3cm_holder\""+pug.attr("data-placement", placement, true, true)+" style=\"display: none;\""+pug.attr("data-module", moduleId, true, true)+" data-showoninit=\"true\" data-calloninit=\"true\" data-ismobile=\"false\"") + "\u003EThank you for your inquiry. A representative will be in contact with you shortly.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E";
block && block();
};
























const expert1 = [require('images/photos/profile-1.jpg?{sizes: [63], format:"webp"}'), require('images/photos/profile-1.jpg')]
const expert2 = [require('images/photos/profile-2.jpg?{sizes: [63], format:"webp"}'), require('images/photos/profile-2.jpg')]
const expert3 = [require('images/photos/profile-3.jpg?{sizes: [63], format:"webp"}'), require('images/photos/profile-3.jpg')]

const moment = require('moment-timezone')
const salesCenterIsAvailable = require('utils/pivot/salesCenterIsAvailable/index.ts')
const {computeHoursForToday, getWeeklySchedule} = salesCenterIsAvailable
const {hours: [start, end]} = computeHoursForToday()
const callCenterIsOpen = start != null && end != null
const startString = moment(start, ['H mm']).format('h:mm a')
const endString = moment(end, ['H mm']).format('h:mm a')
const today = moment().format('dddd')





































































pug_mixins["loading"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv class=\"c-Form__loading d-none d-step-loading-block fadeIn\"\u003E\u003Cdiv class=\"c-Form__step-title\"\u003E\u003Cdiv class=\"c-Form__title-text c-Form__loading-shimmer\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"c-Form__section\"\u003E\u003Cdiv class=\"c-Form__fields align-items-md-center\"\u003E\u003Cdiv class=\"form-group input\"\u003E\u003Cdiv class=\"form-label c-Form__loading-shimmer\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"switch-field switch-field--checkmark switch-field--full-width flex-wrap flex-md-nowrap justify-content-md-start\"\u003E\u003Clabel class=\"radio__btn c-Form__loading-shimmer\"\u003E\u003C\u002Flabel\u003E\u003Clabel class=\"radio__btn c-Form__loading-shimmer\"\u003E\u003C\u002Flabel\u003E\u003Clabel class=\"radio__btn c-Form__loading-shimmer\"\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"c-Form__submit-wrap\"\u003E\u003Cdiv class=\"c-Form__loading-button c-Form__loading-shimmer\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
pug_mixins["step1"] = pug_interp = function(config = {}){
var block = (this && this.block), attributes = (this && this.attributes) || {};
const check = require('images/icons/green-check.svg')
pug_html = pug_html + "\u003Cdiv class=\"c-Form__step1 d-step-loading-none fadeIn\"\u003E\u003Cdiv class=\"c-Form__section c-Form__section--location d-none\"\u003E\u003Cdiv class=\"c-Form__fields\"\u003E\u003Cdiv class=\"form-group input\" id=\"wrap-zip\"\u003E\u003Clabel class=\"form-label d-block\" for=\"zip\"\u003EZIP Code\u003C\u002Flabel\u003E\u003Cdiv class=\"d-inline-block\"\u003E\u003Cinput class=\"form-control\" type=\"tel\" name=\"zip\" id=\"zip\" autocomplete=\"off\" placeholder=\"#####\" pattern=\"[0-9]*\" data-testid=\"census-form-zipInput\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"error-message\" id=\"error-zip\" data-testid=\"census-form-zipError\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
pug_mixins["input"]({name: 'county', type: 'select', label: 'County', mainClass: 'd-none', attributes: {'data-testid': 'census-form-countySelect'}});
if (config.isMediaAlpha) {
pug_html = pug_html + "\u003Cdiv class=\"zipcode-coverage form-group no-mobile d-no-coverage-none\"\u003E\u003Cp\u003E\u003Cimg" + (" class=\"coverage-success__icon\""+pug.attr("src", check, true, true)) + "\u003E\u003C\u002Fp\u003E\u003Ch2 class=\"sub-title green-text\"\u003EWe’ve Got\n\u003Cspan class=\"js-plans-count\"\u003E37\u003C\u002Fspan\u003E\nCoverage Options for" + (pug.escape(null == (pug_interp = ' ') ? "" : pug_interp)) + "\u003Cspan class=\"strong cityState\"\u003EYour State\u003C\u002Fspan\u003E\u003C\u002Fh2\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"c-Form__section c-Form__section--contact\"\u003E\u003Cdiv class=\"c-Form__fields\"\u003E";
pug_mixins["input"].call({
attributes: {"placeholder": "First Name"}
}, {name: 'fname', type: 'text', label: 'Your First Name', help: 'It’ll be friendlier calling you by your name throughout this quote. Plus, it’ll help identify who’s being covered.', attributes: {'data-testid': 'census-form-firstNameInput'}});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"c-Form__section c-Form__section--applicant\"\u003E\u003Cdiv class=\"c-Form__fields\"\u003E\u003Cp class=\"c-Form__child-only d-child-only-block\"\u003EA parent\u002Fcustodian\u002Fguardian must sign on behalf of an applicant under 18 years of age.\u003C\u002Fp\u003E";
pug_mixins["dependent"]({suffix: '', optionsGender, helpDOB: "Your date of birth is required to determine your rate.<br /> Insurance prices are based on your age."});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"c-Form__section c-Form__section--email\"\u003E\u003Cdiv class=\"c-Form__fields\"\u003E";
pug_mixins["input"].call({
attributes: {"placeholder": "email@address.com"}
}, {name: 'email', type: 'email', label: 'Email Address', help: 'Used to send you a copy of quotes, and helps us serve you better.', attributes: {'data-testid': 'census-form-emailInput'}});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"c-Form__section c-Form__section--contact fadeIn d-none\" id=\"phone-container\"\u003E\u003Cdiv class=\"c-Form__fields\"\u003E";
pug_mixins["input"].call({
attributes: {"placeholder": "(000) 000-0000","pattern": "[0-9]*"}
}, { name: 'phone', type: 'tel', label: 'Your Phone', attributes: {'data-testid': 'census-form-phoneInput'} });
pug_mixins["TCPADisclosure"].call({
attributes: {"class": "help-text"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
pug_mixins["dependent"] = pug_interp = function(config){
var block = (this && this.block), attributes = (this && this.attributes) || {};
var dob = `dob${config.suffix}`
var gender = `gender${config.suffix}`
var testSuffix = config.suffix ? config.suffix.replace('_', '') : 'adult'
pug_html = pug_html + "\u003Cdiv" + (" class=\"form-group input\""+pug.attr("id", `wrap-${gender}`, false, true)) + "\u003E\u003Cdiv class=\"form-label\"\u003EGender\u003C\u002Fdiv\u003E";
pug_mixins["radioGroup"].call({
attributes: {"class": "justify-content-start"}
}, {
      name: gender,
      testId: `census-form-genderRadio-${testSuffix}`,
      checkmark: true,
      separated: true,
      options: config.optionsGender
    });
pug_html = pug_html + "\u003Cdiv" + (" class=\"error-message\""+pug.attr("id", `error-${gender}`, false, true)+pug.attr("data-testid", `census-form-genderError-${testSuffix}`, false, true)) + "\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
pug_mixins["input"].call({
attributes: {"placeholder": "MM\u002FDD\u002FYYYY","pattern": "[0-9]*"}
}, {
    name: dob,
    type: 'tel',
    label: 'Date of Birth',
    help: config.helpDOB,
    icon: 'hc-icon-calendar',
    attributes: {'data-testid': `census-form-dateOfBirthInput-${testSuffix}`}
  });
};
pug_mixins["step2"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv class=\"c-Form__step2 d-step-loading-none fadeIn\"\u003E\u003Cdiv class=\"c-Form__section c-Form__section--dependents\"\u003E\u003Cdiv class=\"c-Form__fields\"\u003E\u003Cfieldset class=\"form-group input\" id=\"wrap-add-spouse\"\u003E\u003Cdiv class=\"form-label\"\u003EAre you looking to include your spouse in your health insurance plan?\u003C\u002Fdiv\u003E";
pug_mixins["radioGroup"].call({
attributes: {"class": "justify-content-start"}
}, {
            name: 'add-spouse',
            testId: 'census-form-addSpouseRadio',
            checkmark: true,
            separated: true,
            options: [
              {
                valueText: 'no',
                label: 'No',
                checked: true
              },
              {
                valueText: 'yes',
                label: 'Yes'
              }
            ]
          });
pug_html = pug_html + "\u003C\u002Ffieldset\u003E\u003Cdiv id=\"spouse-wrap\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group input\" id=\"wrap-add-child\"\u003E\u003Cdiv class=\"form-label\"\u003EAre you looking to include your child in your health insurance plan?\u003C\u002Fdiv\u003E";
pug_mixins["radioGroup"].call({
attributes: {"class": "justify-content-start"}
}, {
            name: 'add-child',
            testId: 'census-form-addChildRadio',
            checkmark: true,
            separated: true,
            options: [
              {
                valueText: 'no',
                label: 'No',
                checked: true
              },
              {
                valueText: 'yes',
                label: 'Yes'
              }
            ]
          });
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
pug_mixins["input"]({
          name: 'child-number',
          type: 'select',
          label: 'How many children you want to include?',
          mainClass: 'd-none d-add-children-block fadeIn',
          attributes: {'data-testid': 'census-form-childNumberSelect'},
          options: [
            {
              value: "0",
              label: '--',
              selected: true,
              disabled: true
            },
            {
              value: 1,
              label: 1
            },
            {
              value: 2,
              label: 2
            },
            {
              value: 3,
              label: 3
            },
            {
              value: 4,
              label: 4
            },
            {
              value: 5,
              label: 5
            },
            {
              value: 6,
              label: 6
            },
            {
              value: 7,
              label: 7
            },
            {
              value: 8,
              label: 8
            },
            {
              value: 9,
              label: 9
            },
            {
              value: 10,
              label: 10
            }
          ]
        });
pug_html = pug_html + "\u003Cdiv class=\"c-Form__children\" id=\"children-wrap\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
const optionsGender = [{ valueText: 'f', label: 'Female' }, { valueText: 'm', label: 'Male' }]
if (MULTI_CARRIER_ENABLED && MULTI_CARRIER_ELIGIBILITY) {
pug_mixins["dependent"] = pug_interp = function(config){
var block = (this && this.block), attributes = (this && this.attributes) || {};
var dob = `dob${config.suffix}`
var gender = `gender${config.suffix}`
var testSuffix = config.suffix ? config.suffix.replace('_', '') : 'adult'
pug_html = pug_html + "\u003Cdiv" + (" class=\"form-group input\""+pug.attr("id", `wrap-${gender}`, false, true)) + "\u003E\u003Cdiv class=\"form-label\"\u003EGender\u003C\u002Fdiv\u003E";
pug_mixins["radioGroup"].call({
attributes: {"class": "justify-content-start"}
}, {
      name: gender,
      testId: `census-form-genderRadio-${testSuffix}`,
      checkmark: true,
      separated: true,
      options: config.optionsGender
    });
pug_html = pug_html + "\u003Cdiv" + (" class=\"error-message\""+pug.attr("id", `error-${gender}`, false, true)+pug.attr("data-testid", `census-form-genderError-${testSuffix}`, false, true)) + "\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
pug_mixins["input"].call({
attributes: {"placeholder": "MM\u002FDD\u002FYYYY","pattern": "[0-9]*"}
}, {
    name: dob,
    type: 'tel',
    label: 'Date of Birth',
    help: config.helpDOB,
    icon: 'hc-icon-calendar',
    attributes: {'data-testid': `census-form-dateOfBirthInput-${testSuffix}`}
  });
};
pug_mixins["step3"] = pug_interp = function(config = {}){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv class=\"c-Form__step3 d-step-loading-none fadeIn\"\u003E\u003Cdiv class=\"c-Form__section c-Form__section--dependents\"\u003E\u003Cdiv class=\"c-Form__fields\"\u003E\u003Cfieldset class=\"form-group input\" id=\"wrap-select-multi-carrier\"\u003E \u003Cdiv class=\"form-label\"\u003EAre you looking for coverage for more than 4 months?\u003C\u002Fdiv\u003E";
pug_mixins["radioGroup"].call({
attributes: {"class": "justify-content-start"}
}, {
            name: 'select-multi-carrier',
            testId: 'census-form-multiCarrierRadio',
            checkmark: true,
            separated: true,
            options: [
              {
                valueText: 'no',
                label: 'No',
              },
              {
                valueText: 'yes',
                label: 'Yes',
                checked: true
              }
            ]
          });
pug_html = pug_html + "\u003C\u002Ffieldset\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
}
pug_mixins["form"] = pug_interp = function(config = {}){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv class=\"c-Form-wrap d-md-flex flex-wrap justify-content-md-around justify-content-lg-between align-items-lg-start\"\u003E\u003Cform" + (" class=\"c-Form js-show-overlay mb-2 flex-grow-1\""+pug.attr("action", routesPath.QUOTES, true, true)+" method=\"get\" id=\"form\""+pug.attr("novalidate", true, true, true)) + "\u003E\u003Cinput id=\"leadid_token\" name=\"universal_leadid\" type=\"hidden\" value=\"\"\u003E";
pug_mixins["loading"]();
pug_mixins["step1"](config);
pug_mixins["step2"](config);
if (MULTI_CARRIER_ENABLED && MULTI_CARRIER_ELIGIBILITY) {
pug_mixins["step3"](config);
}
pug_html = pug_html + "\u003Cdiv class=\"c-Form__submit-wrap d-step-loading-none\"\u003E";
pug_mixins["primaryButton"].call({
block: function(){
pug_html = pug_html + "\u003Cspan class=\"primaryButton__cta\"\u003E\u003Cspan class=\"d-finish-block-none\"\u003EContinue\u003C\u002Fspan\u003E\u003Cspan class=\"d-none d-finish-block-inline\"\u003ESee Plans\u003C\u002Fspan\u003E\u003Ci class=\"hc-icon-angle-right d-step-processing-none\"\u003E\u003C\u002Fi\u003E\u003Ci class=\"hc-icon-spinner animate-spin d-none d-step-processing-inline-block\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E";
},
attributes: {"type": "submit","data-testid": "census-form-submitButton"}
}, {name: 'continue-form', cta: 'Continue', withIcon:true});
pug_html = pug_html + "\u003Cp class=\"c-Form__assistance text-center\"\u003ENeed more help? Call us now at\n\u003Ca class=\"c-Form__assistance-link promo_number promo_number_formatted_dash\" id=\"phone-number-census-form\" href=\"#\" onclick=\"dataLayerPushEvent('CALL_CENSUS-BODY')\" data-toggle=\"modal\" data-target=\"#header-modal\"\u003E\u003C\u002Fa\u003E & speak to one of our licensed agents.\u003C\u002Fp\u003E\u003Chr\u003E\u003Cdiv class=\"mt-5\"\u003E" + (null == (pug_interp = require("../../../../pug/notices/census-federal-notice/view.pug").call(this, locals)) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E";
pug_mixins["template"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"c-Form__card fadeIn\" data-testid=\"census-form-memberCard-\u003C%= page.id %\u003E\"\u003E\u003Cbutton class=\"c-Form__close\" type=\"button\" data-id=\"\u003C%= page.id %\u003E\" data-testid=\"census-form-removeMemberButton-\u003C%= page.id %\u003E\"\u003E\u003Ci class=\"hc-icon-trash\"\u003E\u003C\u002Fi\u003ERemove\u003C\u002Fbutton\u003E\u003Ch4 class=\"c-Form__card-title\"\u003E\u003C%= page.title %\u003E\u003C\u002Fh4\u003E\u003Cdiv class=\"c-Form__card-fields\"\u003E";
pug_mixins["dependent"]({suffix: '<%= page.suffix %>', optionsGender});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
}, 'template-member');
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"FadedOverlay\"\u003E\u003C\u002Fdiv\u003E";
pug_mixins["template"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"summary__plan js-show-overlay summary__plan--\u003C%= page.type %\u003E\"\u003E\u003Cspan class=\"summary__plan-body\"\u003E\u003Cspan class=\"summary__plan-description\"\u003E\u003C%= page.description %\u003E\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E";
}
}, 'template-summary-plan');
};
var routesPath = require('sites/routes')
const pathPage = 'census/'

pug_html = pug_html + "\u003Cdiv class=\"pageContainer\"\u003E";
pug_mixins["progressBar"].call({
attributes: {"class": "d-none d-md-block"}
}, {step:1, messages: ['Demographics', 'Quotes', 'Policy Details', 'Eligibility', 'Checkout'], steps: 5});
pug_html = pug_html + "\u003Cdiv class=\"greyContainer\"\u003E\u003Cdiv class=\"globalWrap\"\u003E" + (null == (pug_interp = require("./components/header/view.pug").call(this, locals)) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
pug_mixins["form"]();
pug_html = pug_html + ("\u003C\u002Fdiv\u003E\u003Cdiv class=\"globalWrap\"\u003E" + (null == (pug_interp = require("../components/claims/view.pug").call(this, locals)) ? "" : pug_interp) + "\u003Cdiv class=\"Census__wrap\"\u003E" + (null == (pug_interp = require("../../../../pug/mixins/disclaimer/content.pug").call(this, locals)) ? "" : pug_interp));
pug_mixins["trustPilotSmall"]();
pug_html = pug_html + (null == (pug_interp = require("./components/disclaimer/view.pug").call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = require("../../../../pug/mixins/disclaimer/ada/view.pug").call(this, locals)) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";}.call(this,"Array" in locals_for_with?locals_for_with.Array:typeof Array!=="undefined"?Array:undefined,"MULTI_CARRIER_ELIGIBILITY" in locals_for_with?locals_for_with.MULTI_CARRIER_ELIGIBILITY:typeof MULTI_CARRIER_ELIGIBILITY!=="undefined"?MULTI_CARRIER_ELIGIBILITY:undefined,"MULTI_CARRIER_ENABLED" in locals_for_with?locals_for_with.MULTI_CARRIER_ENABLED:typeof MULTI_CARRIER_ENABLED!=="undefined"?MULTI_CARRIER_ENABLED:undefined,"detail" in locals_for_with?locals_for_with.detail:typeof detail!=="undefined"?detail:undefined));;return pug_html;};
module.exports = template;